module.exports = __webpack_public_path__ + "static/media/logo.f04af94f.png";